var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 238.744,
    height: 253.211,
    viewBox: "0 0 238.744 253.211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 240.466,
    x2: 1.001,
    y2: 240.466,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58499e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23a1db"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    y1: 346.277,
    x2: 1,
    y2: 346.277,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0,
    y1: 217.895,
    x2: 1,
    y2: 217.895,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: 234.707,
    x2: 1.001,
    y2: 234.707,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f16024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4a822"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0,
    y1: 210.112,
    x2: 0.999,
    y2: 210.112,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0,
    y1: 256.557,
    x2: 1,
    y2: 256.557,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.001,
    y1: 210.112,
    x2: 1,
    y2: 210.112,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0,
    y1: 215.763,
    x2: 1,
    y2: 215.763,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    y1: 351.81,
    x2: 1.002,
    y2: 351.81,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed6a25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d05275"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0,
    y1: 422.747,
    x2: 1,
    y2: 422.747,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -0.002,
    y1: 351.81,
    x2: 1,
    y2: 351.81,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e5ba7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#7959a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#a24e9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e64271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -0.002,
    y1: 351.81,
    x2: 1,
    y2: 351.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0,
    y1: 351.81,
    x2: 1,
    y2: 351.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -0.002,
    y1: 351.81,
    x2: 1,
    y2: 351.81,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#56469c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c571ae"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0,
    y1: 351.81,
    x2: 1,
    y2: 351.81,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 0,
    y1: 351.81,
    x2: 1,
    y2: 351.81,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 0,
    y1: 351.81,
    x2: 1.002,
    y2: 351.81,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    y1: 351.81,
    x2: 1,
    y2: 351.81,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#56469c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#956bae"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 0,
    y1: 351.81,
    x2: 1,
    y2: 351.81,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 0,
    y1: 351.81,
    x2: 1.002,
    y2: 351.81,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 0,
    y1: 703.12,
    x2: 1,
    y2: 703.12,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 0.004,
    y1: 703.12,
    x2: 1,
    y2: 703.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 0,
    y1: 703.12,
    x2: 1,
    y2: 703.12,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 0,
    y1: 703.12,
    x2: 1,
    y2: 703.12,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -0.004,
    y1: 703.12,
    x2: 1,
    y2: 703.12,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -0.004,
    y1: 703.12,
    x2: 0.996,
    y2: 703.12,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 0,
    y1: 703.12,
    x2: 1,
    y2: 703.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 0,
    y1: 703.12,
    x2: 1.004,
    y2: 703.12,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -0.004,
    y1: 703.12,
    x2: 1,
    y2: 703.12,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 0.004,
    y1: 703.12,
    x2: 1.004,
    y2: 703.12,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 0,
    y1: 703.12,
    x2: 0.996,
    y2: 703.12,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 0,
    y1: 703.12,
    x2: 1.004,
    y2: 703.12,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -0.004,
    y1: 703.12,
    x2: 0.996,
    y2: 703.12,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    y1: 703.12,
    x2: 1,
    y2: 703.12,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#56469c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55b748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: -0.004,
    y1: 703.12,
    x2: 0.996,
    y2: 703.12,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 0.004,
    y1: 703.12,
    x2: 1.004,
    y2: 703.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: -0.004,
    y1: 703.12,
    x2: 1,
    y2: 703.12,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 0.001,
    y1: 261.891,
    x2: 1,
    y2: 261.891,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 0.002,
    y1: 283.815,
    x2: 1,
    y2: 283.815,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 0,
    y1: 314.169,
    x2: 1.002,
    y2: 314.169,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: -0.001,
    y1: 169.399,
    x2: 1,
    y2: 169.399,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 0,
    y1: 179.74,
    x2: 1,
    y2: 179.74,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 0,
    y1: 214.714,
    x2: 1,
    y2: 214.714,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 0,
    y1: 1046.07,
    x2: 1,
    y2: 1046.07,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 0,
    y1: 1046.07,
    x2: 0.994,
    y2: 1046.07,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 0,
    y1: 1046.07,
    x2: 0.994,
    y2: 1046.07,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 0.006,
    y1: 1046.07,
    x2: 1,
    y2: 1046.07,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 0.006,
    y1: 1046.07,
    x2: 1,
    y2: 1046.07,
    xlinkHref: "#linear-gradient-11"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Price-icon",
    transform: "translate(-3.791 14.467)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1823",
    "data-name": "Ellipse 1823",
    cx: 119.372,
    cy: 119.372,
    r: 119.372,
    transform: "translate(3.791 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Heart",
    transform: "translate(71.341 -14.467)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1508",
    "data-name": "Ellipse 1508",
    cx: 4.487,
    cy: 4.487,
    r: 4.487,
    transform: "translate(93.626 27.694)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1509",
    "data-name": "Ellipse 1509",
    cx: 3.114,
    cy: 3.114,
    r: 3.114,
    transform: "translate(46.206 42.308)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1510",
    "data-name": "Ellipse 1510",
    cx: 4.953,
    cy: 4.953,
    r: 4.953,
    transform: "translate(79.92 16.465)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1511",
    "data-name": "Ellipse 1511",
    cx: 4.597,
    cy: 4.597,
    r: 4.597,
    transform: "translate(55.131 40.334)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1512",
    "data-name": "Ellipse 1512",
    cx: 5.137,
    cy: 5.137,
    r: 5.137,
    transform: "translate(16.71 39.954)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1513",
    "data-name": "Ellipse 1513",
    cx: 4.205,
    cy: 4.205,
    r: 4.205,
    transform: "translate(37.171 8.251)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1514",
    "data-name": "Ellipse 1514",
    cx: 5.137,
    cy: 5.137,
    r: 5.137,
    transform: "translate(16.379 1.532)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1515",
    "data-name": "Ellipse 1515",
    cx: 5.002,
    cy: 5.002,
    r: 5.002,
    transform: "translate(23.747 53.586)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1516",
    "data-name": "Ellipse 1516",
    cx: 3.065,
    cy: 3.065,
    r: 3.065,
    transform: "translate(59.361 57.644)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1517",
    "data-name": "Ellipse 1517",
    cx: 2.55,
    cy: 2.55,
    r: 2.55,
    transform: "translate(42.994 75.482)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1518",
    "data-name": "Ellipse 1518",
    cx: 3.065,
    cy: 3.065,
    r: 3.065,
    transform: "translate(67.942 42.026)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1519",
    "data-name": "Ellipse 1519",
    cx: 3.065,
    cy: 3.065,
    r: 3.065,
    transform: "translate(42.111 59.422)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1520",
    "data-name": "Ellipse 1520",
    cx: 3.065,
    cy: 3.065,
    r: 3.065,
    transform: "translate(4.695 12.37)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1521",
    "data-name": "Ellipse 1521",
    cx: 3.065,
    cy: 3.065,
    r: 3.065,
    transform: "translate(48.486 79.932)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1522",
    "data-name": "Ellipse 1522",
    cx: 3.065,
    cy: 3.065,
    r: 3.065,
    transform: "translate(32.083 3.813)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1523",
    "data-name": "Ellipse 1523",
    cx: 3.065,
    cy: 3.065,
    r: 3.065,
    transform: "translate(61.567 34.511)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1524",
    "data-name": "Ellipse 1524",
    cx: 3.065,
    cy: 3.065,
    r: 3.065,
    transform: "translate(17.323 23.305)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1525",
    "data-name": "Ellipse 1525",
    cx: 3.065,
    cy: 3.065,
    r: 3.065,
    transform: "translate(57.46 72.405)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1526",
    "data-name": "Ellipse 1526",
    cx: 3.065,
    cy: 3.065,
    r: 3.065,
    transform: "translate(68.371 61.101)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1527",
    "data-name": "Ellipse 1527",
    cx: 3.065,
    cy: 3.065,
    r: 3.065,
    transform: "translate(97.512 19.309)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1528",
    "data-name": "Ellipse 1528",
    cx: 3.065,
    cy: 3.065,
    r: 3.065,
    transform: "translate(31.017 64.166)",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1529",
    "data-name": "Ellipse 1529",
    cx: 3.065,
    cy: 3.065,
    r: 3.065,
    transform: "translate(2.133 34.511)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1530",
    "data-name": "Ellipse 1530",
    cx: 3.065,
    cy: 3.065,
    r: 3.065,
    transform: "translate(63.774 9.305)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1531",
    "data-name": "Ellipse 1531",
    cx: 3.065,
    cy: 3.065,
    r: 3.065,
    transform: "translate(41.388 67.452)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1532",
    "data-name": "Ellipse 1532",
    cx: 3.065,
    cy: 3.065,
    r: 3.065,
    transform: "translate(56.296 10.972)",
    fill: "url(#linear-gradient-25)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1533",
    "data-name": "Ellipse 1533",
    cx: 3.065,
    cy: 3.065,
    r: 3.065,
    transform: "translate(45.176 27.792)",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1534",
    "data-name": "Ellipse 1534",
    cx: 3.065,
    cy: 3.065,
    r: 3.065,
    transform: "translate(27.952 46.574)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1535",
    "data-name": "Ellipse 1535",
    cx: 3.065,
    cy: 3.065,
    r: 3.065,
    transform: "translate(68.96 23.992)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1536",
    "data-name": "Ellipse 1536",
    cx: 3.065,
    cy: 3.065,
    r: 3.065,
    transform: "translate(31.017 23.992)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1537",
    "data-name": "Ellipse 1537",
    cx: 3.065,
    cy: 3.065,
    r: 3.065,
    transform: "translate(25.684 13.902)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1538",
    "data-name": "Ellipse 1538",
    cx: 3.065,
    cy: 3.065,
    r: 3.065,
    transform: "translate(66.827 1.569)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1539",
    "data-name": "Ellipse 1539",
    cx: 3.065,
    cy: 3.065,
    r: 3.065,
    transform: "translate(77.995 0.037)",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1540",
    "data-name": "Ellipse 1540",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(69.904 51.515)",
    fill: "url(#linear-gradient-33)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1541",
    "data-name": "Ellipse 1541",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(63.897 71.228)",
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1542",
    "data-name": "Ellipse 1542",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(75.249 57.657)",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1543",
    "data-name": "Ellipse 1543",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(65.809 54.972)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1544",
    "data-name": "Ellipse 1544",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(21.001 34.265)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1545",
    "data-name": "Ellipse 1545",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(65.613 66.557)",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1546",
    "data-name": "Ellipse 1546",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(49.774 67.244)",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1547",
    "data-name": "Ellipse 1547",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(76.781 22.447)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1548",
    "data-name": "Ellipse 1548",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(45.115 36.337)",
    fill: "url(#linear-gradient-41)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1549",
    "data-name": "Ellipse 1549",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(49.639 56.124)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1550",
    "data-name": "Ellipse 1550",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(55.143 79.748)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1551",
    "data-name": "Ellipse 1551",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(51.76 72.76)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1552",
    "data-name": "Ellipse 1552",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(81.612 9.942)",
    fill: "url(#linear-gradient-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1553",
    "data-name": "Ellipse 1553",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(42.651 52.851)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1554",
    "data-name": "Ellipse 1554",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(27.216 21.761)",
    fill: "url(#linear-gradient-47)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1555",
    "data-name": "Ellipse 1555",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(13.915 48.977)",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1556",
    "data-name": "Ellipse 1556",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(40.567 24.396)",
    fill: "url(#linear-gradient-49)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1557",
    "data-name": "Ellipse 1557",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(70.492 19.051)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1558",
    "data-name": "Ellipse 1558",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(11.708 45.054)",
    fill: "#2ab34b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1559",
    "data-name": "Ellipse 1559",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(61.567 5.345)",
    fill: "url(#linear-gradient-51)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1560",
    "data-name": "Ellipse 1560",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(11.328 12.37)",
    fill: "url(#linear-gradient-52)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1561",
    "data-name": "Ellipse 1561",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(82.347 27.265)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1562",
    "data-name": "Ellipse 1562",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(13.24 28.7)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1563",
    "data-name": "Ellipse 1563",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(63.1 28.516)",
    fill: "url(#linear-gradient-55)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1564",
    "data-name": "Ellipse 1564",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(45.115 19.811)",
    fill: "url(#linear-gradient-51)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1565",
    "data-name": "Ellipse 1565",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(53.084 17.519)",
    fill: "url(#linear-gradient-57)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1566",
    "data-name": "Ellipse 1566",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(11.708 5.137)",
    fill: "url(#linear-gradient-47)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1567",
    "data-name": "Ellipse 1567",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(53.611 61.432)",
    fill: "url(#linear-gradient-47)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1568",
    "data-name": "Ellipse 1568",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(57.681 65.699)",
    fill: "url(#linear-gradient-57)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1569",
    "data-name": "Ellipse 1569",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(92.78 39.108)",
    fill: "url(#linear-gradient-61)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1570",
    "data-name": "Ellipse 1570",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(70.492 33.934)",
    fill: "url(#linear-gradient-33)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1571",
    "data-name": "Ellipse 1571",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(77.566 50.509)",
    fill: "url(#linear-gradient-47)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1572",
    "data-name": "Ellipse 1572",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(84.701 3.592)",
    fill: "url(#linear-gradient-64)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1573",
    "data-name": "Ellipse 1573",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(90.88 27.265)",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1574",
    "data-name": "Ellipse 1574",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(18.512 14.932)",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1575",
    "data-name": "Ellipse 1575",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(27.952 2.28)",
    fill: "url(#linear-gradient-47)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1576",
    "data-name": "Ellipse 1576",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(27.731 37.575)",
    fill: "url(#linear-gradient-68)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1577",
    "data-name": "Ellipse 1577",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(34.082 18.5)",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1578",
    "data-name": "Ellipse 1578",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(64.62 16.465)",
    fill: "url(#linear-gradient-70)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1579",
    "data-name": "Ellipse 1579",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(6.73 8.41)",
    fill: "url(#linear-gradient-49)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1580",
    "data-name": "Ellipse 1580",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(87.815 10.837)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1581",
    "data-name": "Ellipse 1581",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(25.439 30.857)",
    fill: "#2ab34b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1582",
    "data-name": "Ellipse 1582",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(77.566 31.299)",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1583",
    "data-name": "Ellipse 1583",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(27.829 8.974)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1584",
    "data-name": "Ellipse 1584",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(51.944 25.524)",
    fill: "#2ab34b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1585",
    "data-name": "Ellipse 1585",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(13.915 35.467)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1586",
    "data-name": "Ellipse 1586",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(18.965 54.248)",
    fill: "url(#linear-gradient-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1587",
    "data-name": "Ellipse 1587",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(36.779 59.177)",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1588",
    "data-name": "Ellipse 1588",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(53.599 52.851)",
    fill: "url(#linear-gradient-78)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1589",
    "data-name": "Ellipse 1589",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(90.022 4.732)",
    fill: "url(#linear-gradient-47)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1590",
    "data-name": "Ellipse 1590",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(36.681 51.515)",
    fill: "#2ab34b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1591",
    "data-name": "Ellipse 1591",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(94.178 19.051)",
    fill: "url(#linear-gradient-41)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1592",
    "data-name": "Ellipse 1592",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(76.034 37.575)",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1593",
    "data-name": "Ellipse 1593",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(84.664 32.39)",
    fill: "url(#linear-gradient-33)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1594",
    "data-name": "Ellipse 1594",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(74.501)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1595",
    "data-name": "Ellipse 1595",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(37.735 65.907)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1596",
    "data-name": "Ellipse 1596",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(60.893 52.495)",
    fill: "url(#linear-gradient-47)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1597",
    "data-name": "Ellipse 1597",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(90.181 35.651)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1598",
    "data-name": "Ellipse 1598",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(12.762 19.713)",
    fill: "url(#linear-gradient-78)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1599",
    "data-name": "Ellipse 1599",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(48.842 16.734)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1600",
    "data-name": "Ellipse 1600",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(37.551 32.39)",
    fill: "url(#linear-gradient-47)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1601",
    "data-name": "Ellipse 1601",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(53.611 35.013)",
    fill: "#2ab34b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1602",
    "data-name": "Ellipse 1602",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(8.018 42.026)",
    fill: "url(#linear-gradient-51)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1603",
    "data-name": "Ellipse 1603",
    cx: 1.532,
    cy: 1.532,
    r: 1.532,
    transform: "translate(37.551 72.76)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1604",
    "data-name": "Ellipse 1604",
    cx: 4.119,
    cy: 4.119,
    r: 4.119,
    transform: "translate(55.622 19.86)",
    fill: "url(#linear-gradient-92)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1605",
    "data-name": "Ellipse 1605",
    cx: 3.8,
    cy: 3.8,
    r: 3.8,
    transform: "translate(36.043 39.096)",
    fill: "url(#linear-gradient-93)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1606",
    "data-name": "Ellipse 1606",
    cx: 3.433,
    cy: 3.433,
    r: 3.433,
    transform: "translate(93.001 9.023)",
    fill: "url(#linear-gradient-94)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1607",
    "data-name": "Ellipse 1607",
    cx: 6.375,
    cy: 6.375,
    r: 6.375,
    transform: "translate(78.804 38.716)",
    fill: "url(#linear-gradient-95)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1608",
    "data-name": "Ellipse 1608",
    cx: 6.007,
    cy: 6.007,
    rx: 6.007,
    ry: 6.007,
    transform: "translate(0 19.922)",
    fill: "url(#linear-gradient-96)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1609",
    "data-name": "Ellipse 1609",
    cx: 5.026,
    cy: 5.026,
    r: 5.026,
    transform: "translate(71.007 8.202)",
    fill: "url(#linear-gradient-97)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1610",
    "data-name": "Ellipse 1610",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(31.617 33.223)",
    fill: "#58499e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1611",
    "data-name": "Ellipse 1611",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(41.069 19.64)",
    fill: "#58499e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1612",
    "data-name": "Ellipse 1612",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(13.375 9.477)",
    fill: "#58499e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1613",
    "data-name": "Ellipse 1613",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(10.31 32.892)",
    fill: "#58499e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1614",
    "data-name": "Ellipse 1614",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(49.663 62.56)",
    fill: "#58499e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1615",
    "data-name": "Ellipse 1615",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(65.809 48.989)",
    fill: "#58499e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1616",
    "data-name": "Ellipse 1616",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(77.762 27.768)",
    fill: "#58499e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1617",
    "data-name": "Ellipse 1617",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(65.282 21.748)",
    fill: "#58499e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1618",
    "data-name": "Ellipse 1618",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(74.501 4.61)",
    fill: "#58499e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1619",
    "data-name": "Ellipse 1619",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(98.849 15.937)",
    fill: "#58499e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1620",
    "data-name": "Ellipse 1620",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(92.412 43.558)",
    fill: "#58499e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1621",
    "data-name": "Ellipse 1621",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(82.114 52.544)",
    fill: "#58499e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1622",
    "data-name": "Ellipse 1622",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(70.995 56.627)",
    fill: "#58499e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1623",
    "data-name": "Ellipse 1623",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(49.124 50.485)",
    fill: "#2ab34b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1624",
    "data-name": "Ellipse 1624",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(2.133 17.507)",
    fill: "#2ab34b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1625",
    "data-name": "Ellipse 1625",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(79.601 55.474)",
    fill: "#2ab34b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1626",
    "data-name": "Ellipse 1626",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(91.383 15.937)",
    fill: "#2ab34b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1627",
    "data-name": "Ellipse 1627",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(101.582 26.664)",
    fill: "#2ab34b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1628",
    "data-name": "Ellipse 1628",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(46.488 13.51)",
    fill: "#2ab34b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1629",
    "data-name": "Ellipse 1629",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(34.118 36.546)",
    fill: "#2ab34b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1630",
    "data-name": "Ellipse 1630",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(59.728 31.801)",
    fill: "#2ab34b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1631",
    "data-name": "Ellipse 1631",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(56.651 57.644)",
    fill: "#2ab34b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1632",
    "data-name": "Ellipse 1632",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(23.036 20.216)",
    fill: "#2ab34b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1633",
    "data-name": "Ellipse 1633",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(19.015 31.36)",
    fill: "#f16024"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1634",
    "data-name": "Ellipse 1634",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(18.512 19.051)",
    fill: "#f16024"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1635",
    "data-name": "Ellipse 1635",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(54.285 31.36)",
    fill: "#f16024"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1636",
    "data-name": "Ellipse 1636",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(33.567 13.228)",
    fill: "#f16024"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1637",
    "data-name": "Ellipse 1637",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(40.346 48.609)",
    fill: "#f16024"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1638",
    "data-name": "Ellipse 1638",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(30.588 42.884)",
    fill: "#f16024"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1639",
    "data-name": "Ellipse 1639",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(75.004 47.089)",
    fill: "#f16024"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1640",
    "data-name": "Ellipse 1640",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(75.004 54.236)",
    fill: "#f16024"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1641",
    "data-name": "Ellipse 1641",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(87.962 28.7)",
    fill: "#f16024"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1642",
    "data-name": "Ellipse 1642",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(92.057 22.95)",
    fill: "#f16024"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1643",
    "data-name": "Ellipse 1643",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(86.699 7.993)",
    fill: "#f16024"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1644",
    "data-name": "Ellipse 1644",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(54.114 68.911)",
    fill: "#f16024"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1645",
    "data-name": "Ellipse 1645",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(62.07 67.881)",
    fill: "#f16024"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1646",
    "data-name": "Ellipse 1646",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(53.255 76.867)",
    fill: "#2ab34b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1647",
    "data-name": "Ellipse 1647",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(48.094 72.552)",
    fill: "url(#linear-gradient-98)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1648",
    "data-name": "Ellipse 1648",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(50.522 38.078)",
    fill: "url(#linear-gradient-98)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1649",
    "data-name": "Ellipse 1649",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(70.995 38.372)",
    fill: "url(#linear-gradient-100)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1650",
    "data-name": "Ellipse 1650",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(25.622 26.432)",
    fill: "url(#linear-gradient-101)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1651",
    "data-name": "Ellipse 1651",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(14.797 15.521)",
    fill: "url(#linear-gradient-100)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1652",
    "data-name": "Ellipse 1652",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(23.036 12.873)",
    fill: "url(#linear-gradient-103)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1653",
    "data-name": "Ellipse 1653",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(18.512 36.288)",
    fill: "url(#linear-gradient-100)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1654",
    "data-name": "Ellipse 1654",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(14.393 40.763)",
    fill: "url(#linear-gradient-105)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1655",
    "data-name": "Ellipse 1655",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(10.985 37.686)",
    fill: "url(#linear-gradient-100)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1656",
    "data-name": "Ellipse 1656",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(24.065 50.485)",
    fill: "url(#linear-gradient-98)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1657",
    "data-name": "Ellipse 1657",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(49.774 22.95)",
    fill: "url(#linear-gradient-98)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1658",
    "data-name": "Ellipse 1658",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(41.621 30.551)",
    fill: "url(#linear-gradient-98)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1659",
    "data-name": "Ellipse 1659",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(67.329 31.151)",
    fill: "url(#linear-gradient-105)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1660",
    "data-name": "Ellipse 1660",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(75.004 19.186)",
    fill: "url(#linear-gradient-101)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1661",
    "data-name": "Ellipse 1661",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(74.219 31.581)",
    fill: "url(#linear-gradient-98)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1662",
    "data-name": "Ellipse 1662",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(81.085 35.516)",
    fill: "url(#linear-gradient-100)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1663",
    "data-name": "Ellipse 1663",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(90.353 32.181)",
    fill: "url(#linear-gradient-105)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1664",
    "data-name": "Ellipse 1664",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(90.684 19.64)",
    fill: "url(#linear-gradient-100)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1665",
    "data-name": "Ellipse 1665",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(53.795 48.989)",
    fill: "url(#linear-gradient-98)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275",
    transform: "translate(0 -9)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_225_Special_Launch_Price_185_for_a_limited_time",
    "data-name": "$225  Special Launch Price $185* *for a limited time",
    transform: "translate(6.1 93)",
    fill: "#212731",
    fontSize: 28,
    fontFamily: "Nunito-BoldItalic, Nunito",
    fontStyle: "italic",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 84,
    y: 28
  }, "$225 "), /*#__PURE__*/React.createElement("tspan", {
    fill: "#c12ec1",
    fontSize: 20
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 23,
    y: 56
  }, "Special Launch Price "), /*#__PURE__*/React.createElement("tspan", {
    x: 78,
    y: 84,
    fontSize: 28
  }, "$185*")), /*#__PURE__*/React.createElement("tspan", {
    fill: "#c12ec1",
    fontSize: 20,
    fontFamily: "Nunito-Italic, Nunito",
    fontWeight: 400
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 38,
    y: 112
  }, "*for a limited time"))), /*#__PURE__*/React.createElement("line", {
    id: "Line_454",
    "data-name": "Line 454",
    y1: 33,
    x2: 65,
    transform: "translate(92.6 93)",
    fill: "none",
    stroke: "#c12ec1",
    strokeLinecap: "round",
    strokeWidth: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceIcon);
export default __webpack_public_path__ + "static/media/price-icon.49d1f93b0af85d77bccc73484db9f7e1.svg";
export { ForwardRef as ReactComponent };